import { render, staticRenderFns } from "./OcrConfigManage.vue?vue&type=template&id=0b49c23e&scoped=true"
import script from "./OcrConfigManage.vue?vue&type=script&lang=js"
export * from "./OcrConfigManage.vue?vue&type=script&lang=js"
import style0 from "./OcrConfigManage.vue?vue&type=style&index=0&id=0b49c23e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b49c23e",
  null
  
)

export default component.exports